export const OrderItemChangeStateEnum = {
  Unchanged: 0,
  Added: 1,
  Deleted: 2,
  Modified: 3,
}

export type OrderItemChangeState = typeof OrderItemChangeStateEnum[keyof typeof OrderItemChangeStateEnum]
